<template>
  <FreeButton
    class="button"
    :class="{
      active: isActive,
    }"
    type="button"
    @click="openSort"
  >
    <!-- eslint-disable -->
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.201 8.164a.833.833 0 0 1 .002-1.179l3.916-3.908a.833.833 0 0 1 1.422.59v12.666a.833.833 0 0 1-1.666 0V5.676L4.38 8.165a.833.833 0 0 1-1.179-.001ZM11.972 17.103a.833.833 0 0 1-.514-.77V3.667a.833.833 0 0 1 1.667 0v10.655l2.494-2.494a.833.833 0 1 1 1.178 1.178l-3.916 3.917a.833.833 0 0 1-.909.18Z"
        fill="currentColor"
      />
    </svg>
    <!-- eslint-enable -->
    <span>
      <slot />
    </span>
  </FreeButton>
</template>

<script setup lang="ts">
  import { FreeButton } from 'freedom-shared';

  import { offerSortModel } from '@/features/offer-sort';

  import { analyticsEventsLib } from '@/shared/lib';

  const sortingBottomSheet = offerSortModel.sortingBottomSheetController();

  defineProps<{
    isActive: boolean;
  }>();

  const openSort = () => {
    analyticsEventsLib.sortSeparateClick();
    sortingBottomSheet.show();
  };
</script>

<style scoped lang="postcss">
  .button {
    @apply text-text-neutral-secondary bg-background-neutral-secondary border-situational-lightgrey space-x-2 whitespace-nowrap rounded-xl border px-3 py-2 text-sm font-medium leading-5 transition-colors duration-150;

    &.active {
      @apply text-text-positive-primary border-background-positive-primary;
    }
  }
</style>
